import React from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";

import Button from "components/atoms/Button/Button";

function CustomsInvoiceBanner() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div
      className="d-flex align-items-center"
      style={{
        marginLeft: "26px",
        marginBottom: " 16px",
        marginRight: "8px",
        backgroundColor: "#FA604B",
        height: "58px",
        borderRadius: "16px",
        padding: "16px",
      }}
    >
      <div className="text-white">
        <FormattedMessage
          id="billing.submitCustomsBrokerageInvoice"
          defaultMessage="Please submit the Customs brokerage invoice"
        />
      </div>
      <Button onClick={() => navigate(`/shipment/${id}/billing`)} className="ml-3" variant="light">
        <FormattedMessage id="billing.submitInvoice" defaultMessage="Submit Invoice" />
      </Button>
    </div>
  );
}

export default CustomsInvoiceBanner;
